module.exports = __webpack_public_path__ + "static/media/ccb_thumb.ab92c183.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/ccb_thumb.png
// module id = 183
// module chunks = 0